import { OSType } from './index';

export const searchQueryKeyList: (keyof SearchQueryType)[] = [
  'osType',
  'version',
  'qaMode',
  'id',
];

export type SearchQueryKeyType = (typeof searchQueryKeyList)[number];
export interface SearchQueryType {
  osType?: OSType;
  version?: string;
  qaMode?: boolean;
  id?: string;
}
